import getUrlQueryParams from "./getUrlQueryParams";
import {IApiServiceHandler} from "./apiServiceHandler";

export class UseService {
    apiService: IApiServiceHandler;

    constructor(apiService: IApiServiceHandler) {
        this.apiService = apiService;
    }

    service(service: string) {
        return new Service(this.apiService, service);
    }
}

class Service {
    apiService: IApiServiceHandler;
    service: string;

    constructor(apiService: IApiServiceHandler, servicePros: string) {
        this.apiService = apiService;
        this.service = servicePros;
    }

    async find(filter = {query: {}}) {
        const urlQueriesParams = getUrlQueryParams(filter.query);
        return {
            data: await this.apiService.api(this.service + urlQueriesParams, "GET"),
        };
    }

    create(items: any) {
        return this.apiService.api(this.service, "POST", items);
    }

    post(items: any) {
        return this.apiService.api(this.service, "POST", items);
    }

    options() {
        return this.apiService.api(this.service, "OPTIONS");
    }

    patch(updateItemId: number, updateItem: any) {
        return this.apiService.api(
            this.service + `${updateItemId}/`,
            "PATCH",
            updateItem
        );
    }

    remove(deleteItemId: number) {
        return this.apiService.api(this.service + `${deleteItemId}/`, "DELETE");
    }

    get(id: number | null = null, queryDict: Record<string, any> = null) {
        let url = id !== null ? `${id}/` : "";
        if (queryDict) {
            const urlQueriesParams = getUrlQueryParams(queryDict);
            url += urlQueriesParams;
        }
        return this.apiService.api(this.service + url, "GET");
    }

    getBlob(id: number | null = null, fileName: string | null = null) {
        const url = id !== null ? `${id}/` : "";
        return this.apiService.api(this.service + url, "GET_BLOB", fileName);
    }

    downloadBlob(id: number | null = null, fileName: string | null = null) {
        const url = id !== null ? `${id}/` : "";
        return this.apiService.api(this.service + url, "DOWNLOAD_BLOB", fileName);
    }
}
